/** Номер календарного дня (локального) — для «вернулся на следующий день» и счёта сессий за день. */
export function dayNumber(ms: number): number {
  const d = new Date(ms);
  return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86_400_000);
}
